<template>
  <div>
    <div>
      <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
      <h3 class="mt-3">
        {{ $getVisibleNames("cideu.acttype", false, "Tipo de Acta") }}
        <AlternativeNameButton
          :table_name="'cideu.acttype'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h3>
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <ButtonMedium
            v-can="'cideu.add_acttype'"
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames(
                  'cideu.acttype',
                  false,
                  'Tipo de Acta'
                ),
              })
            "
            :text_button="$t('reusable.common.add')"
            :click_button="() => $bvModal.show(`new-act-type-modal`)"
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
          <!-- Tipo de Acta -->
        </div>
      </div>
      <GenericBTable
        v-if="searchActType.length > 0"
        :items="act_types"
        :pagination="act_types.length"
        :fields="actTypesFields"
        :filter="input_search"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="true"
        :allows_crud="allows_crud"
        :display_id="display_id"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template> </template>
        <template v-if="allows_crud" #cell(actions)="row">
          <ButtonSmall
            :tooltip_text="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'cideu.acttype',
                  false,
                  'Tipo de Acta'
                ),
              })
            "
            :click_button="
              () => $bvModal.show(`edit-act-type-modal-${row.item.id}`)
            "
            :class="`mx-1`"
            :icon="'square'"
          ></ButtonSmall>
          <ButtonSmall
            :click_button="() => askForDeleteActType(row.item.id)"
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames(
                  'cideu.acttype',
                  false,
                  'Tipo de Acta'
                ),
              })
            "
            :icon="'trash'"
          ></ButtonSmall>
          <b-modal
            :id="`edit-act-type-modal-${row.item.id}`"
            :title="
              $t('reusable.common.editModalTitle', {
                entity: $getVisibleNames(
                  'cideu.acttype',
                  false,
                  'Tipo de Acta'
                ),
              })
            "
            size="lg"
            hide-footer
          >
            <ActTypeForm
              :actType="row.item"
              @updated="slotUpdatedActType"
              :institution_id="row.item.school"
              :show_title="false"
            ></ActTypeForm>
          </b-modal>
        </template>
        <template #cell(description)="row">
          <RenderVHtml :content="row.item.description"></RenderVHtml>
        </template>
        <template #cell(is_institutional)="row">
          {{
            row.item.is_institutional
              ? $t("reusable.common.yes")
              : $t("reusable.common.no")
          }}
        </template>
      </GenericBTable>
      <div v-else>
        <br />
        <strong>
          {{ $t("reusable.common.noDataFound") }}
          {{ $getVisibleNames("cideu.acttype", false, "Tipo de Acta") }}.
        </strong>
      </div>
    </div>
    <b-modal
      :id="`new-act-type-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames('cideu.acttype', false, 'Tipo de Acta'),
        })
      "
      size="lg"
    >
      <ActTypeForm
        @created="slotCreatedActType"
        :institution_id="this.user.school"
      ></ActTypeForm>
    </b-modal>
  </div>
</template>
<script>
// import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "ActTypeView",
  components: {
    ActTypeForm: () =>
      import("@/components/mesh/CurricularResources/ActType/ActTypeForm"),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {
    input_search: {
      type: String,
      default: "",
    },
    display_id: {},
  },
  data() {
    return {
      act_types: [],
      sortBy: "",
      sortDesc: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    breadcrumb_items() {
      return [
        {
          text: this.$t("reusable.breadcrumb.home"),
          to: "/home",
        },
        {
          text: this.$getVisibleNames("cideu.acttype", false, "Tipo de Acta"),
        },
      ];
    },
    allows_crud() {
      const has_permission = this.$hasPermissions("cideu.add_acttype");
      if (has_permission) return has_permission;
      else return false;
    },
    searchActType: function () {
      return this.act_types
        .filter((item) => {
          return (
            item.name.toLowerCase().includes(this.input_search.toLowerCase()) ||
            item.description
              .toLowerCase()
              .includes(this.input_search.toLowerCase())
          );
        })
        .sort(function (a, b) {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
    },
    actTypesFields() {
      if (!this.allows_crud)
        return this.actTypes_fields.filter(
          (field) => !field.requires_allows_crud
        );
      else return this.actTypes_fields;
    },
    actTypes_fields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames("cideu.acttype", true, "Tipos de Actas")
          ),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "description",
          label: this.$t("reusable.common.description"),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "is_institutional",
          label: this.$t("reusable.common.isInstitutional"),
          sortable: true,
          tdClass: "text-center",
          display_column: true,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    askForDeleteActType(act_type_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames("cideu.acttype", false, "Tipo de Acta"),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$restful.Delete(`/cideu/act-type/${act_type_id}/`).then(() => {
            toast(
              this.$t("reusable.common.deletedSuccessfully", {
                entity: this.$getVisibleNames(
                  "cideu.acttype",
                  false,
                  "Tipo de Acta"
                ),
              })
            );
          });
          let index = this.act_types.findIndex((x) => x.id == act_type_id);
          if (index != -1) this.act_types.splice(index, 1);
        }
      });
    },
    mutateActType(act_type) {
      let index = this.act_types.findIndex((x) => x.id == act_type.id);
      if (index != -1) this.act_types.splice(index, 1, act_type);
      else this.act_types.push(act_type);
    },
    slotCreatedActType(act_type) {
      this.mutateActType(act_type);
      this.$bvModal.hide("new-act-type-modal");
    },
    slotUpdatedActType(act_type) {
      this.mutateActType(act_type);
      this.$bvModal.hide(`edit-act-type-modal-${act_type.id}`);
    },
    fetchActTypes() {
      this.$restful.GetAll("/cideu/act-type/").then((response) => {
        this.act_types = response;
      });
    },
  },
  mounted() {},
  created() {
    this.fetchActTypes();
  },
};
</script>

<style scoped>
th {
  background-color: var(--primary-color);
  border-radius: 6px;
  box-shadow: 1px 1px 3px rgb(72, 72, 72);
}

.title-header {
  padding: 0;
  margin-top: auto;
}
.search-modality {
  max-width: 50rem;
  margin-left: auto;
  margin-right: 18.5%;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}
.edit-section {
  margin-top: -2%;
}
</style>